export default __webpack_public_path__ + "static/media/CU.398e382c.svg";